import React, { useEffect, useContext, useState} from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login';
import Logout from './components/Logout';
import { ProtectedRoute } from './ProtectedRoute';
import Dashboard from './components/Dashboard';
import { UserProvider } from './contexts/UserContext';
import { CMSProvider } from './contexts/CMSContext';
import { ACSProvider } from './contexts/ACSContext';
import useLog from './hooks/useLog';
import './App.css';
import i18n from './i18n';

const App = () => {
  const {LogInfo} = useLog();
  LogInfo('App starting');
  // Render different views

  useEffect(() => {
    LogInfo('changing language direction');
    const dir = i18n.language === 'he' ? 'rtl' : 'ltr';
    document.documentElement.dir = dir;
  }, [i18n.language]);

  // Main render
return (
  <CMSProvider>
    <ACSProvider>
      <UserProvider>
        <Router>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<ProtectedRoute component={<Dashboard />} />} />
            <Route path="/logout" element={<Logout />} />
          </Routes>
        </Router>
      </UserProvider>
    </ACSProvider>
  </CMSProvider>
);
};


export default App;